import React, { useEffect, useState } from 'react';
import ReservationShowDetail from '../ReservationShowDetail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot } from '@fortawesome/free-regular-svg-icons';
import { getToday, checkDayWithOther2Day } from '../../../utils/Date/SupportDate';
import './reservationSchedule.css';
import { useSelector } from 'react-redux';
// import RoomCell from './RoomCell';
// import { precomputeSchedule } from '../../../utils/precomputeSchedule';
const style = {
    backgroundColor: {
        oldDay: "rgba(211 211 211 / 50%)",
        newDay: "rgba(144 238 144 / 65%)"
    }
};

function ReservationScheduleComponent2(props) {
    const { data, selectRoomType, listRender, onFinish, renderNumber, showComponent } = props;


    // ⭐ GLOBAL TOOLTIP STATE
    const [globalTooltip, setGlobalTooltip] = useState(null);
    const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });

    const isCheckMode = false;
    const ruleRenderNumber = 15;

    const auth = useSelector(state => state.auth);
    const { branchID } = auth.user;
    const numbers = !branchID ? 0 : listRender === "listReservation"
        ? renderNumber === 1 ? ruleRenderNumber - 1
            : data.listNumberRoom.length > ruleRenderNumber ? data.listNumberRoom.length - 1 : 0
        : Math.max(0, Object.keys(data[listRender]).length - 1);

    // useEffect(() => {
    //     if (!isCheckMode) {
    //         const handleClick = () => setShow(false);
    //         window.addEventListener('click', handleClick);
    //         return () => window.removeEventListener('click', handleClick);
    //     }
    // }, []);

    useEffect(() => {
        if (numbers === ruleRenderNumber - 1 && listRender === "listReservation" && renderNumber === 1) {
            onFinish();
        }
        else if (renderNumber === 2 && listRender === "listReservation" && numbers === data.listNumberRoom.length - 1) {
            onFinish();
        }
        else if (listRender === "listWaiting" &&
            (numbers === Object.keys(data[listRender]).length - 1 ||
                Object.keys(data[listRender]).length === 0)) {
            onFinish();
        }
    }, [onFinish, numbers, listRender, renderNumber, data]);

    function checkRoomWithStyle(room) {
        var result;
        const listKeyOnListRoom = Object.keys(data.listRoom);
        listKeyOnListRoom.forEach(roomCheck => {
            if (data.listRoom[roomCheck].includes(room)) result = roomCheck;
        });
        return result;
    }

    function renderSchedule() {
        var result = [];

        if (listRender === "listReservation") {
            if (renderNumber === 1) {
                for (let i = 0; i < ruleRenderNumber; i++) {
                    if (selectRoomType === checkRoomWithStyle(data.listNumberRoom[i]) || selectRoomType === "All") {
                        result.push(
                            <div className="d-flex rsv-ca">
                                {renderRoom(data.listNumberRoom[i])}
                            </div>
                        );
                    }
                }
            } else {
                for (let j = ruleRenderNumber; j < data.listNumberRoom.length; j++) {

                    if (selectRoomType === checkRoomWithStyle(data.listNumberRoom[j]) || selectRoomType === "All") {
                        result.push(
                            <div className="d-flex rsv-ca">
                                {renderRoom(data.listNumberRoom[j])}
                            </div>
                        );
                    }
                }
            }
        } else {
            const listKey = Object.keys(data[listRender]);

            for (let i = 0; i < listKey.length; i++) {

                if (selectRoomType === checkRoomWithStyle(listKey[i]) || selectRoomType === "All") {
                    result.push(
                        <div className="d-flex rsv-ca">
                            {renderRoom(listKey[i])}
                        </div>
                    );
                }
            }
        }

        return result;
    }

    function renderRoom(roomNumber) {
        var result = [];

        function distributionRoomEmpty(dataShorten, dataExtend, index, dataRoom) {
            if (index === 0) {
                if (dataExtend === "" && index !== (data.listShowDate.length - 1)) {
                    return "rsv-room";
                }

                if (dataExtend !== "") {
                    if (dataExtend.timeEarly.slice(0, 2) < 15)
                        return "rsv-room_half";
                    else return "rsv-room";
                }
            } else {

                if (dataExtend !== "" && dataShorten !== "" && dataExtend && dataShorten) {
                    if ("timeEarly" in dataExtend && "timeLateOut" in dataShorten) {
                        if (
                            index > 0 &&
                            Number(dataExtend.timeEarly.slice(0, 2)) < 15 &&
                            dataShorten.timeLateOut !== "12:00"
                        ) {
                            if (dataShorten.nights === 0) return "rsv-room_half";
                            return "op-hidden";
                        }
                    }
                }

                if (
                    index > 0 &&
                    dataShorten !== "" &&
                    dataShorten.timeLateOut !== "12:00" &&
                    Number(dataShorten.timeLateOut.slice(0, 2)) > 12 &&
                    dataShorten.nights !== 0
                ) {
                    if (dataExtend !== "" && dataExtend !== undefined) {
                        if (Number(dataExtend.timeEarly.slice(0, 2)) < 15) {
                            return "rsv-room";
                        } else {
                            return "rsv-room_half";
                        }
                    } else {
                        return "rsv-room_half";
                    }
                } else if (
                    index > 0 &&
                    index !== (data.listShowDate.length - 1) &&
                    dataExtend !== "" &&
                    Number(dataExtend.timeEarly.slice(0, 2)) < 15 &&
                    dataExtend.nights === 0
                ) {
                    return "rsv-room_half";
                } else if (
                    index > 0 &&
                    index !== (data.listShowDate.length - 1) &&
                    dataExtend !== "" &&
                    Number(dataExtend.timeEarly.slice(0, 2)) < 15 &&
                    dataExtend.nights !== 0
                ) {
                    return "rsv-room_half";
                } else {
                    return "rsv-room";
                }
            }
        }

        const today = getToday();
        const dataRoom = data[listRender] === undefined ? undefined : data[listRender][roomNumber];

        function checkShowSmallIcon(numberCheck, data) {
            if (data) {
                const { move, pickUp, rentCar, userId, payment } = data;
                let numberShow = 0;

                if (userId && userId !== "") numberShow += 1;
                if (move) {
                    numberShow += 1;
                    if (numberCheck === 2) return numberShow;
                }
                if (payment === "Pre-Pay") {
                    numberShow += 1;
                    if (numberCheck === 3) return numberShow;
                }
                if (pickUp !== "") {
                    numberShow += 1;
                    if (numberCheck === 4) return numberShow;
                }
                if (rentCar) numberShow += 1;

                return numberShow;
            }
        }

        function attachTooltipEvents(cellData) {
            return {
                onMouseEnter: (e) => {
                    setTooltipPos({ x: e.clientX + 10, y: e.clientY + 10 });
                    setGlobalTooltip(cellData);
                },
                onMouseMove: (e) => {
                    setTooltipPos({ x: e.clientX + 10, y: e.clientY + 10 });
                },
                onMouseLeave: () => setGlobalTooltip(null)
            };
        }

        if (dataRoom) {
            for (let i = 0; i <= data.listShowDate.length - 1; i++) {
                const checkMonth = checkDayWithOther2Day(today, (data.month + "-" + String(i + 1).padStart(2, '0')));
                const canNotEdit = checkMonth === 1 || listRender === "listCancel" || listRender === "listWaiting";

                /* ---------------------
                 * CASE 1: EMPTY SLOT
                 * --------------------- */
                if (dataRoom[i] === "") {
                    result.push(
                        <div
                            className={distributionRoomEmpty(
                                Array.isArray(dataRoom[i - 1]) ? dataRoom[i - 1][dataRoom[i - 1].length - 1] : dataRoom[i - 1],
                                Array.isArray(dataRoom[i + 1]) ? dataRoom[i + 1][0] : dataRoom[i + 1],
                                i,
                                dataRoom
                            )}
                            style={{ backgroundColor: canNotEdit ? style.backgroundColor.oldDay : "" }}
                            onClick={
                                canNotEdit ? () => { } :
                                    () => window.open(`/room/${data.branchID}/${roomNumber}/${data.month}-${String(i + 1).padStart(2, '0')}`, "_blank")
                            }
                            {...attachTooltipEvents(null)}
                        >
                            {(isCheckMode ? "X1" : "") + String(i + 1).padStart(2, '0')}
                        </div>
                    );
                }

                /* ---------------------
                 * CASE 2: SINGLE OBJECT
                 * --------------------- */
                else if (!Array.isArray(dataRoom[i])) {
                    const cell = dataRoom[i];
                    if (!("name" in cell)) continue;

                    const lengthRoom = cell.nights;

                    const lateOut =
                        (cell.timeLateOut.slice(0, 2) > 12 && cell.timeLateOut !== "12:00") ? 40 : 0;

                    const earlyCheckInShorten =
                        (Number(cell.timeEarly.slice(0, 2)) > 15 && cell.timeEarly !== "15:00")
                            ? (i === 0 ? 40 : 40)
                            : 0;

                    const earlyCheckInExtend =
                        (Number(cell.timeEarly.slice(0, 2)) < 15 && cell.timeEarly !== "15:00") ? 40 : 0;

                    function checkWith() {
                        // giữ nguyên toàn bộ logic width gốc của bạn
                        if (lengthRoom === 0) {
                            if (earlyCheckInShorten !== 0) return 40;
                            if (earlyCheckInExtend !== 0 && lateOut !== 0) return 80;
                            if (earlyCheckInExtend !== 0 && lateOut === 40) return 80;
                        }

                        if (lengthRoom === 1 && earlyCheckInShorten === 40) {
                            if (lateOut === 40) return 80;
                            return 40;
                        }

                        return (lengthRoom * 80 + lateOut - earlyCheckInShorten + earlyCheckInExtend);
                    }

                    result.push(
                        <div
                            className="rsv-room active"
                            onClick={() => window.open(`/room/${data.branchID}/${cell.id}`, "_blank")}
                            style={{
                                backgroundColor: listRender === "listWaiting"
                                    ? cell.userBooking ? "#ea9999" : "gray"
                                    : cell.status === "confirm"
                                        ? cell.color
                                        : "black",
                                width: checkWith()
                            }}
                            {...attachTooltipEvents(cell)}
                        >
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex  align-items-center">
                                    {(checkWith() >= 80 && cell.timeEarly !== "15:00") &&
                                        <FontAwesomeIcon className="mr-1" icon={faCircleDot} />}
                                    {(isCheckMode ? "X2" : "") + cell.name}
                                </div>

                                {(cell.userId && cell.userId !== "") &&
                                    <i className="fa-solid fa-star show-small-icon_left1"></i>}
                                {(cell.move && listRender === "listReservation") &&
                                    <i className={`fa-solid fa-lock show-small-icon_left${checkShowSmallIcon(2, cell)}`}></i>}
                                {cell.payment === "Pre-Pay" &&
                                    <i className={`fa-solid fa-sack-dollar show-small-icon_left${checkShowSmallIcon(3, cell)}`}></i>}
                                {cell.pickUp !== "" &&
                                    <i className={`fa-solid fa-plane show-small-icon_left${checkShowSmallIcon(5, cell)}`}></i>}
                                {cell.rentCar &&
                                    <i className={`fa-solid fa-car show-small-icon_left${checkShowSmallIcon(4, cell)}`}></i>}
                                {cell.dropOff !== "" &&
                                    <i className="fa-solid fa-plane show-small-icon_right1"></i>}

                                {(checkWith() >= 80 && cell.timeLateOut !== "12:00") &&
                                    <FontAwesomeIcon icon={faCircleDot} />}
                            </div>
                        </div>
                    );
                }

                /* ---------------------
                 * CASE 3: ARRAY (DOUBLE BOOKING)
                 * --------------------- */
                else if (Array.isArray(dataRoom[i])) {
                    dataRoom[i].forEach((roomOnDataRoom, index) => {

                        const checkTimeEarlyHour = Number(roomOnDataRoom.timeEarly.slice(0, 2));
                        const lateOut =
                            (roomOnDataRoom.timeLateOut.slice(0, 2) > 12 && roomOnDataRoom.timeLateOut !== "12:00")
                                ? 40 : 0;
                        const earlyCheckInShorten =
                            (checkTimeEarlyHour > 15 && roomOnDataRoom.timeEarly !== "15:00") ? 40 : 0;
                        const earlyCheckInExtend =
                            (checkTimeEarlyHour < 15 && roomOnDataRoom.timeEarly !== "15:00") ? 40 : 0;

                        function checkNightZero(dataShort, dataExtend) {
                            return roomOnDataRoom.nights * 80 + lateOut - earlyCheckInShorten + earlyCheckInExtend;
                        }

                        const checkWith = checkNightZero(
                            Array.isArray(dataRoom[i - 1])
                                ? dataRoom[i - 1][dataRoom[i - 1].length - 1]
                                : dataRoom[i - 1],
                            Array.isArray(dataRoom[i + 1])
                                ? dataRoom[i + 1][0]
                                : dataRoom[i + 1]
                        );

                        result.push(
                            <div
                                className="rsv-room active"
                                onClick={() => window.open(`/room/${data.branchID}/${roomOnDataRoom.id}`, "_blank")}
                                style={{
                                    backgroundColor:
                                        roomOnDataRoom.status === "confirm" ? roomOnDataRoom.color : "black",
                                    width: checkWith
                                }}
                                {...attachTooltipEvents(roomOnDataRoom)}
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        {checkWith >= 80 &&
                                            <FontAwesomeIcon className="mr-1" icon={faCircleDot} />}
                                        {(isCheckMode ? "Y2" : "") + roomOnDataRoom.name}
                                    </div>

                                    {roomOnDataRoom.move &&
                                        <i className="fa-solid fa-lock show-small-icon_left1"></i>}
                                    {roomOnDataRoom.payment === "Pre-Pay" &&
                                        <i className={`fa-solid fa-sack-dollar show-small-icon_left${checkShowSmallIcon(2, roomOnDataRoom)}`}></i>}
                                    {roomOnDataRoom.pickUp !== "" &&
                                        <i className={`fa-solid fa-plane show-small-icon_left${checkShowSmallIcon(4, roomOnDataRoom)}`}></i>}
                                    {roomOnDataRoom.rentCar &&
                                        <i className={`fa-solid fa-car show-small-icon_left${checkShowSmallIcon(3, roomOnDataRoom)}`}></i>}
                                    {roomOnDataRoom.dropOff !== "" &&
                                        <i className="fa-solid fa-plane show-small-icon_right1"></i>}

                                    {checkWith >= 80 &&
                                        <FontAwesomeIcon icon={faCircleDot} />}
                                </div>
                            </div>
                        );
                    });
                }
            }
        }

        return result;
    }

        return (
        <div
            className={listRender === "listReservation" ? "d-flex" : "d-flex"}
            style={{
                paddingTop:
                    listRender === "listReservation" && renderNumber === 1
                        ? "7.3px"
                        : "unset"
            }}
        >
            <div className="rsv">
                <div
                    style={{
                        paddingTop:
                            listRender === "listReservation" &&
                            renderNumber === 1
                                ? "26px"
                                : ""
                    }}
                >
                    {branchID && renderSchedule()}
                </div>
            </div>

            {/* ⭐ GLOBAL TOOLTIP — chỉ 1 tooltip duy nhất */}
            {globalTooltip && (
                <div
                    style={{
                        position: "fixed",
                        top: tooltipPos.y,
                        left: tooltipPos.x,
                        background: "white",
                        border: "1px solid #ccc",
                        padding: "10px",
                        borderRadius: "6px",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
                        zIndex: 999999,
                        pointerEvents: "none",
                        maxWidth: "320px"
                    }}
                >
                    <ReservationShowDetail
                        showComponent={showComponent}
                        dataRender={globalTooltip}
                    />
                </div>
            )}
        </div>
    );
}

export default ReservationScheduleComponent2;
